import { render, staticRenderFns } from "./CategoryManagement.vue?vue&type=template&id=98843092"
import script from "./CategoryManagement.vue?vue&type=script&lang=js"
export * from "./CategoryManagement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports